import createStore from './framework/store';

const initialPresenterLayout =
  window.initialPresenterLayout &&
  (window.initialPresenterLayout.renderManifest ||
    window.initialPresenterLayout);

const store = createStore(initialPresenterLayout);

export default store;
